// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".balance--gameplay .amount--total[data-v-62f0bb68] {\n  font-size: 1.13rem;\n}\n.balance--gameplay .item .title[data-v-62f0bb68],\n.balance--gameplay .item .amount[data-v-62f0bb68] {\n  font-size: 0.75rem;\n}", ""]);
// Exports
module.exports = exports;
